
import React from 'react';
import { Button } from '@/components/ui/button';
import { Loader2, Trash2, Clock } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Dialog, DialogTrigger } from '@/components/ui/dialog';

interface UpdateActionsProps {
  selectedUpdates: number[];
  onBulkFrequencyUpdate: (frequency: string) => void;
  onDeleteSelected: () => void;
  onProcessUpdates: () => void;
  isProcessing: boolean;
  frequencies: { value: string; label: string }[];
  setIsDialogOpen: (open: boolean) => void;
}

export const UpdateActions: React.FC<UpdateActionsProps> = ({
  selectedUpdates,
  onBulkFrequencyUpdate,
  onDeleteSelected,
  onProcessUpdates,
  isProcessing,
  frequencies,
  setIsDialogOpen
}) => {
  return (
    <div className="flex gap-2">
      {selectedUpdates.length > 0 && (
        <>
          <div className="flex items-center gap-2">
            <Clock className="h-4 w-4 text-gray-500" />
            <Select onValueChange={onBulkFrequencyUpdate}>
              <SelectTrigger className="w-[180px]">
                <SelectValue placeholder="Update frequency" />
              </SelectTrigger>
              <SelectContent>
                {frequencies.map((freq) => (
                  <SelectItem key={freq.value} value={freq.value}>
                    {freq.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <Button 
            variant="destructive"
            onClick={onDeleteSelected}
            className="flex items-center gap-2"
          >
            <Trash2 className="h-4 w-4" />
            Delete Selected ({selectedUpdates.length})
          </Button>
        </>
      )}
      <Button 
        onClick={onProcessUpdates}
        disabled={isProcessing}
      >
        {isProcessing ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Processing...
          </>
        ) : (
          'Process Updates Now'
        )}
      </Button>
      <Dialog>
        <DialogTrigger asChild>
          <Button onClick={() => setIsDialogOpen(true)}>Add New Update</Button>
        </DialogTrigger>
      </Dialog>
    </div>
  );
};
